import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import Moment from 'react-moment'
import classNames from 'classnames'
import Tooltip from 'components/tooltip/Tooltip'
import { Modal } from 'components/dialog/Modals'
import GroupListModal from 'features/creative/list/GroupListModal'
import {
  BizChannelTypeNames,
  BizChannelTypes,
  OperationStatus,
  ReviewStatus,
  ReviewTargetType,
} from 'features/Codes'
import Button from 'components/form/Button'
import NoneAnchor from 'components/NoneAnchor'
import { stripKeywordTag } from 'features/creative/creativeUtil'
import CreativeLibraryPropTypes from './CreativeLibraryPropTypes'
import { setOpenDetailIds } from './creativeListSlice'
import { useDispatch, useSelector } from 'react-redux'
import { showReviewReason } from '../../reviewReason/reviewReasonSlice' // noinspection NonAsciiCharacters

// noinspection NonAsciiCharacters
const BizChannelOperations = {
  '운영 불가 (관리자 정지)': OperationStatus.OFF_BY_BIZ_CHANNEL_ADMIN.msg,
  '운영 불가 (심사 미승인)':
    OperationStatus.OFF_BY_BIZ_CHANNEL_APPROVING_OR_REJECTED.msg,
  '운영 불가 (톡채널 조회불가)':
    OperationStatus.OFF_BY_BIZ_CHANNEL_TALK_CHANNEL_VIEW.msg,
  삭제: '비즈채널이 삭제되었습니다.',
}
const CreativeListItemBasic = ({
  data: {
    id,
    creativeName,
    title,
    description,
    reviewStatus,
    bizChannelType,
    bizChannelName,
    bizChannelPcUrl,
    bizChannelMobileUrl,
    bizChannelOperationStatus,
    deleted,
    adGroupCount,
    createdDate,
    assetTypes,
    talkChannelName,
    talkChannelPermalink,
    talkChannelProposalPhrase,
  },
  onClickItem,
}) => {
  const dispatch = useDispatch()
  const { openDetailIds } = useSelector(state => state.creative.creativeList)
  const { isLoading } = useSelector(state => state.reviewReason)
  const [showAdGroup, setShowAdGroup] = useState(false)
  const handleReasonClick = useCallback(() => {
    dispatch(
      showReviewReason({
        id,
        reviewTargetType: ReviewTargetType.CREATIVE,
      })
    )
  }, [dispatch, id])
  const handleClickDetail = useCallback(
    () => dispatch(setOpenDetailIds(id)),
    [dispatch, id]
  )
  return (
    <>
      <td>
        <div className="inner_tbl">
          {deleted ? (
            <>
              <span className="txt_limit2">{creativeName}</span>
              <span className="txt_error">(삭제)</span>
            </>
          ) : (
            <NoneAnchor className="link_txt txt_limit2" onClick={onClickItem}>
              {creativeName}
            </NoneAnchor>
          )}
        </div>
      </td>
      <td className="td_state">
        <div className="inner_tbl">
          {reviewStatus === ReviewStatus.REJECTED_APPROVAL.name ? (
            <>
              <Tooltip
                position="alignTop right"
                content={
                  <>
                    소재가 심사 가이드에 맞지 않아 보류되었습니다.
                    <br />
                    보류 사유 확인 후 재심사 요청해주세요.
                  </>
                }>
                {ReviewStatus[reviewStatus].title}
              </Tooltip>
              <div className="wrap_btn">
                <Button
                  size="small"
                  onClick={handleReasonClick}
                  loading={isLoading}>
                  사유
                </Button>
              </div>
            </>
          ) : (
            ReviewStatus[reviewStatus].title
          )}
        </div>
      </td>
      <td className="td_meterial">
        <div className="inner_tbl">
          <strong className="tit_meterial">
            {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
              ? stripKeywordTag(title)
              : talkChannelName}
          </strong>
          <span className="txt_link">
            {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
              ? bizChannelMobileUrl || bizChannelPcUrl
              : talkChannelPermalink}
          </span>
          <span className="txt_tag">
            {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
              ? stripKeywordTag(description)
              : talkChannelProposalPhrase}
          </span>
          {bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL &&
            assetTypes.length > 0 && (
              <NoneAnchor
                className={classNames('link_depthitem', {
                  on: openDetailIds.includes(id),
                })}
                onClick={handleClickDetail}>
                <span className="ico_comm ico_depth" />
              </NoneAnchor>
            )}
        </div>
      </td>
      <td>
        <div className="inner_tbl">{BizChannelTypeNames[bizChannelType]}</div>
      </td>
      <td>
        <div className="inner_tbl">
          {bizChannelName}
          <br />
          {bizChannelMobileUrl && (
            <span className="limit_line">{bizChannelMobileUrl}</span>
          )}
          {bizChannelPcUrl && (
            <span className="limit_line">{bizChannelPcUrl}</span>
          )}
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          <p className="ad_state ico_state">
            {bizChannelOperationStatus === '운영 가능' ? (
              <>
                <span className="ico_on">on</span>
                {bizChannelOperationStatus}
              </>
            ) : (
              <Tooltip
                position="bottom alignLeft"
                content={
                  <>
                    <strong className="tit_tooltip">
                      {bizChannelOperationStatus}
                    </strong>
                    <p className="txt_tooltip2">
                      {BizChannelOperations[bizChannelOperationStatus]}
                    </p>
                  </>
                }>
                <span className="ico_off">off</span>
                {bizChannelOperationStatus}
              </Tooltip>
            )}
          </p>
        </div>
      </td>
      <td className="align_c">
        <div className="inner_tbl">
          <button
            className="fc_emph"
            onClick={() => setShowAdGroup(!showAdGroup)}>
            {adGroupCount}
          </button>
          <Modal
            on={showAdGroup}
            className="registgroup_layer"
            onBackgroundClick={() => false}>
            <GroupListModal
              id={id}
              handleClose={() => setShowAdGroup(!showAdGroup)}
            />
          </Modal>
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          <Moment format="YYYY.MM.DD">{createdDate}</Moment>
        </div>
      </td>
    </>
  )
}

export default CreativeListItemBasic

CreativeListItemBasic.propTypes = {
  data: CreativeLibraryPropTypes.isRequired,
  onClickItem: PropTypes.func.isRequired,
}
